"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelConsignmentPath = exports.cancelConsignment = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const cancelConsignment = (client) => async ({ checkoutId, consignmentId }) => {
    try {
        await client.delete((0, exports.cancelConsignmentPath)(checkoutId, consignmentId));
        return utils_1.Result.success();
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.cancelConsignment = cancelConsignment;
const cancelConsignmentPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}`;
exports.cancelConsignmentPath = cancelConsignmentPath;
